import { useSuspenseQuery } from '@tanstack/react-query';
import type { Element } from '@outdoria/types';
import { fetcher } from '../utils';
import { ADMIN_ELEMENTS_ALL } from '../queryKeys';

export const useAdminGetAllElements = () => {
  const queryFn = async (): Promise<Element[]> => {
    const res = await fetcher(`/v2/admin/elements`);
    return res.json();
  };

  const {
    data = [],
    isLoading,
    isFetched,
    isError,
  } = useSuspenseQuery<Element[], unknown, Element[], string[]>({
    queryKey: ADMIN_ELEMENTS_ALL,
    queryFn: queryFn,
  });

  return { data, isLoading, isFetched, isError };
};
